@if (tags) {
    <div
        class="tags"
    >
        @if (title) {
            <h3
                class="tags__title"
            >
                {{ title }}
            </h3>
        }
        <ul
            class="tags-container"
            [class.tags-container--right-aligned]="rightAligned"
            [attr.aria-label]="ariaLabel"
        >
            @for (tag of tags; track $index) {
                @if (typeof tag === 'string') {
                    <li
                        class="tags-container__tag"
                    >
                        {{ tag }}
                    </li>
                } @else {
                    <li
                        class="tags-container__tag"
                        [ngStyle]="{ color: tag.color, borderColor: tag.color }"
                    >
                        {{ tag.label }}
                    </li>
                }
            }
        </ul>
    </div>
}
